// src/components/ScenariosModal.tsx

import React from 'react';
import { ModalContent, ModalTitle } from './styles';
import { useLayers } from '../../context/LayersContext';
import { geoLayers, Layer } from './layers';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { FormControlLabel } from '@mui/material';
import { StyledCheckbox, TreeViewContainer } from '../CheckboxTreeView/styles';

interface ScenariosModalProps {
  show: boolean;
  onClose: (value: boolean | ((prev: boolean) => boolean)) => void;
}

export default function ScenariosModal() {
  const { layers, addNewLayer } = useLayers();

  function leafTitlesOf(parent: Layer): string[] {
    const stack: Layer[] = [parent];
    const leaves: string[] = [];

    while (stack.length) {
      const node = stack.pop()!;
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => stack.push(child));
      } else if (node.title) {
        leaves.push(node.title);
      }
    }

    return leaves;
  }

  function handleToggleParent(parent: Layer) {
    if (!parent.children) return;

    const childrenTitles = leafTitlesOf(parent);
    const allActive = childrenTitles.every((t) => layers.includes(t));

    let newLayers: string[];
    if (allActive) {
      newLayers = layers.filter((l) => !childrenTitles.includes(l));
    } else {
      const missing = childrenTitles.filter((t) => !layers.includes(t));
      newLayers = [...layers, ...missing];
    }

    addNewLayer(newLayers);
  }

  return (
    <ModalContent>
      <ModalTitle>Cenários (APIs)</ModalTitle>

      <TreeViewContainer
        defaultCollapseIcon={<ExpandLessIcon />}
        defaultExpandIcon={<ExpandMoreIcon />}
        expanded={[]}
        onNodeToggle={() => {}}
      >
        {geoLayers.map((parent) => {
          if (!parent.children || parent.children.length === 0) return null;

          const childrenTitles = leafTitlesOf(parent);
          const isChecked =
            childrenTitles.length > 0 &&
            childrenTitles.every((t) => layers.includes(t));
          const isIndeterminate =
            childrenTitles.some((t) => layers.includes(t)) && !isChecked;

          return (
            <TreeItem
              key={parent.title}
              nodeId={parent.title}
              label={
                <FormControlLabel
                  control={
                    <StyledCheckbox
                      checked={isChecked}
                      indeterminate={isIndeterminate}
                      onChange={() => handleToggleParent(parent)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  }
                  label={parent.title}
                  onClick={(e) => e.stopPropagation()}
                />
              }
            />
          );
        })}
      </TreeViewContainer>
    </ModalContent>
  );
}
